import React from 'react'
import { Container, Typography, Stack, Link, Divider, Box } from '@mui/material'
import Layout from '../components/Layout'
import { useTranslation } from 'react-i18next'

const Impressum: React.FC = () => {
  const { t } = useTranslation()

  return (
    <Layout>
      <Container maxWidth="md" sx={{ py: 6 }}>
        <Typography variant="h4" fontWeight={800} gutterBottom>
          {t('imprint')}
        </Typography>
        <Stack spacing={4}>
          <Stack spacing={1}>
            <Typography variant="subtitle1" fontWeight={700}>
              Angaben gemäß § 5 TMG
            </Typography>
            <Typography component="div">
              <Box component="span" display="block">Webmix-IT</Box>
              <Box component="span" display="block">c/o SquashPaT</Box>
              <Box component="span" display="block">Deutschland</Box>
            </Typography>
            <Typography>
              E-Mail:{' '}
              <Link href="mailto:hallo@webmix-it.de">hallo@webmix-it.de</Link>
            </Typography>
          </Stack>

          <Stack spacing={1}>
            <Typography variant="subtitle1" fontWeight={700}>
              Vertretungsberechtigte Person
            </Typography>
            <Typography>
              Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV: Webmix-IT –
              Projektleitung SquashPaT.
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Operative Anschrift und persönliche Termine werden aus
              organisatorischen Gründen nur nach vorheriger Anfrage
              mitgeteilt.
            </Typography>
          </Stack>

          <Stack spacing={1}>
            <Typography variant="subtitle1" fontWeight={700}>
              Umsatzsteuer-Identifikationsnummer
            </Typography>
            <Typography>Wird auf Anfrage mitgeteilt.</Typography>
            <Typography variant="body2" color="text.secondary">
              Nach § 19 UStG (Kleinunternehmerregelung) wird aktuell keine
              Umsatzsteuer ausgewiesen.
            </Typography>
          </Stack>

          <Divider flexItem />

          <Stack spacing={1}>
            <Typography variant="subtitle1" fontWeight={700}>
              Haftung für Inhalte
            </Typography>
            <Typography variant="body2">
              Als Diensteanbieter sind wir gemäß § 7 Abs. 1 TMG für eigene
              Inhalte auf diesen Seiten nach den allgemeinen Gesetzen
              verantwortlich. Nach §§ 8 bis 10 TMG sind wir als
              Diensteanbieter jedoch nicht verpflichtet, übermittelte oder
              gespeicherte fremde Informationen zu überwachen oder nach
              Umständen zu forschen, die auf eine rechtswidrige Tätigkeit
              hinweisen. Verpflichtungen zur Entfernung oder Sperrung der
              Nutzung von Informationen nach den allgemeinen Gesetzen bleiben
              hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst
              ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung
              möglich. Bei Bekanntwerden von entsprechenden
              Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
            </Typography>
          </Stack>

          <Stack spacing={1}>
            <Typography variant="subtitle1" fontWeight={700}>
              Haftung für Links
            </Typography>
            <Typography variant="body2">
              Unser Angebot enthält Links zu externen Webseiten Dritter, auf
              deren Inhalte wir keinen Einfluss haben. Deshalb können wir für
              diese fremden Inhalte auch keine Gewähr übernehmen. Für die
              Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter
              oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten
              wurden zum Zeitpunkt der Verlinkung auf mögliche
              Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum
              Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente
              inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne
              konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar.
              Bei Bekanntwerden von Rechtsverletzungen werden wir derartige
              Links umgehend entfernen.
            </Typography>
          </Stack>

          <Stack spacing={1}>
            <Typography variant="subtitle1" fontWeight={700}>
              Urheberrecht
            </Typography>
            <Typography variant="body2">
              Die durch die Seitenbetreiber erstellten Inhalte und Werke auf
              diesen Seiten unterliegen dem deutschen Urheberrecht. Die
              Vervielfältigung, Bearbeitung, Verbreitung und jede Art der
              Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen
              der schriftlichen Zustimmung des jeweiligen Autors bzw.
              Erstellers. Downloads und Kopien dieser Seite sind nur für den
              privaten, nicht kommerziellen Gebrauch gestattet. Soweit die
              Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden,
              werden die Urheberrechte Dritter beachtet und entsprechende
              Inhalte als solche gekennzeichnet. Sollten Sie trotzdem auf eine
              Urheberrechtsverletzung aufmerksam werden, bitten wir um einen
              entsprechenden Hinweis. Bei Bekanntwerden von
              Rechtsverletzungen werden wir derartige Inhalte umgehend
              entfernen.
            </Typography>
          </Stack>

          <Stack spacing={1}>
            <Typography variant="subtitle1" fontWeight={700}>
              Alternative Streitbeilegung
            </Typography>
            <Typography variant="body2">
              Die Europäische Kommission stellt eine Plattform zur
              Online-Streitbeilegung (OS) bereit:{' '}
              <Link href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener">
                https://ec.europa.eu/consumers/odr
              </Link>
              . Wir sind weder verpflichtet noch bereit, an
              Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle
              teilzunehmen. Unser bevorzugter Weg ist die direkte Kommunikation
              per E-Mail.
            </Typography>
          </Stack>
        </Stack>
      </Container>
    </Layout>
  )
}

export default Impressum
